import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../header';
import Footer from '../../footer';
import Sfirst from '../Sfirst';
import Ssecond from '../Ssecond';
import Sfourth from '../Sfourth';
import Sfifth from '../Sfifth';
import Ssixth from '../Ssixth';
import Sseventh from '../Sseventh';
import Seighth from '../Seighth';
import Snineth from '../Snineth';
import Stenth from '../Stenth';
import Sfifteen from '../Sfifteen';
import s from './Sstyle.module.scss';
import common from '../../../../../locale/common'

class Sstyle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      language: null,
      position: false,
      hideModal: true,
      hideSecondSub: true
    };
    this._handleScroll = this.handleScroll.bind(this);
  }
  
  componentDidMount () {
    const { locale } = this.props
    const local = locale.slice(3).toLocaleLowerCase()
    document.title = common['duck3_' + local]
    
    let browserLanguage = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
    switch (browserLanguage) {
      case 'en':
        browserLanguage = 'en-US';
        break;
      case 'zh':
        browserLanguage = 'zh-CN';
        break;
      default:
        browserLanguage = 'en-US';
    }
    this.setState({
      language: browserLanguage
    });
    window.addEventListener('scroll', this._handleScroll);
  }
  componentWillUnmount () {
    window.removeEventListener('scroll', this._handleScroll);
  }
  handleScroll () {
    const textRect = this.refs.box.getBoundingClientRect();
    if (textRect.top < -50 && this.refs.box) {
      this.setState({
        position: true
      });
    } else {
      this.setState({
        position: false
      });
    }
  }
  hideModalFunc(isHide, e) {
    if (e.target.className === 'language_choice') {
      return
    }
    this.setState({
      hideModal: isHide
    })
  }
  
  hideSecondSubFunc(isHide, e) {
    if (e.target.attributes && e.target.attributes.name && e.target.attributes.name.value === 'secondSub') {
      return
    }
    this.setState({
      hideSecondSub: isHide
    })
  }
  
  render () {
    const { hideModal, hideSecondSub } = this.state
    const { location } = this.props;
    const path = this.props.match.path;
    return (
      <div className={s.box} ref="box" onClick={e => {e.persist(); this.hideModalFunc(true, e); this.hideSecondSubFunc(true, e)}}>
        <div className={s.Sstyle}>
          <Header location={location} language={this.state.language} path={path} navPosition={this.state.position}  hideSecondSub={hideSecondSub} hideSecondSubFunc={(isHide, e) => {this.hideSecondSubFunc(isHide, e)}} />
          {/* 这里只配置了Header，其他内容根据需求添加 */}
          <Sfirst />
          <Ssecond />
          <Sfourth />
          <Sfifth />
          <Ssixth />
          <Sseventh />
          <Seighth />
          <Snineth />
          <Stenth />
          <Sfifteen />
          <Footer location={location} hideModal={hideModal} hideModalFunc={(isShow, e) => {this.hideModalFunc(isShow, e)}} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language
});

let SStyle = connect(mapStateToProps)(Sstyle);

export default SStyle; 